import { useMemo } from "react";
import { CalendarDays, Flame, Trophy, TrendingUp } from "lucide-react";

// Monday 00:00 this week in Sydney, returned as an instant (Date).
function sydneyWeekStart() {
  const now = new Date();
  const sydneyWall = new Date(
    now.toLocaleString("en-US", { timeZone: "Australia/Sydney" }),
  );
  const offsetMs = sydneyWall.getTime() - now.getTime();
  const wall = new Date(sydneyWall);
  wall.setHours(0, 0, 0, 0);
  wall.setDate(wall.getDate() - ((wall.getDay() + 6) % 7));
  return new Date(wall.getTime() - offsetMs);
}

export default function PipelineStats({ data }) {
  const stats = useMemo(() => {
    const rows = [
      ...(data?.service_enquiries || []),
      ...(data?.leads || []),
    ];
    const weekStart = sydneyWeekStart();
    const thisWeek = rows.filter(
      (r) => r.created_at && new Date(r.created_at) >= weekStart,
    ).length;
    const open = rows.filter((r) => ["new", "contacted"].includes(r.status || "new")).length;
    const won = rows.filter((r) => r.status === "won").length;
    const lost = rows.filter((r) => r.status === "lost").length;
    const winRate = won + lost > 0 ? Math.round((won / (won + lost)) * 100) : null;
    return { thisWeek, open, won, winRate };
  }, [data]);

  const items = [
    { key: "this-week", label: "New this week", value: stats.thisWeek, icon: CalendarDays, color: "#FFD700" },
    { key: "open", label: "Open pipeline", value: stats.open, icon: Flame, color: "#0055FF" },
    { key: "won", label: "Deals won", value: stats.won, icon: Trophy, color: "#00C2B8" },
    {
      key: "win-rate",
      label: "Win rate",
      value: stats.winRate == null ? "—" : `${stats.winRate}%`,
      icon: TrendingUp,
      color: "#FF007F",
    },
  ];

  return (
    <div
      data-testid="admin-stats-bar"
      className="mt-8 grid grid-cols-2 lg:grid-cols-4 gap-3"
    >
      {items.map((s) => (
        <div
          key={s.key}
          data-testid={`admin-stat-${s.key}`}
          className="rounded-2xl border-2 border-[#1A1A1A] bg-white p-4 nb-shadow-sm flex items-center gap-3"
        >
          <span
            className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border-2 border-[#1A1A1A] nb-shadow-sm"
            style={{ backgroundColor: s.color }}
          >
            <s.icon size={17} strokeWidth={2.5} className="text-[#1A1A1A]" />
          </span>
          <div className="min-w-0">
            <p className="font-display font-black text-2xl leading-none tracking-tighter">
              {s.value}
            </p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-[#4A4A4A] truncate">
              {s.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
